import axios from "axios"
import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/init.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import "@icon-park/vue-next/styles/index.css"

axios.interceptors.response.use(
    response => {
        if (response.data.code === "500") {
            return Promise.reject(response)
        }
        return response
    },
    error => {
        return Promise.reject(error)
    }
)

const app = createApp(App);
app.use(store);
app.use(router);
app.use(ElementPlus, {locale: zhCn});
app.mount('#app');
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
